import edu3 from '../images/cyber-security.png';
import edu2 from '../images/database.png';
import eduLogo from '../images/development.png';
import edu1 from '../images/frontend.png';
import mainLogo from '../images/sami logo cemintic.png';

const Education = () => (
  <section id="myEducation" className="mt-5 py-5 bg-dark text-white">
    <div className="container">
      <div className="row">

       {/* Sticky Image Section */}
<div className="col-lg-6 mb-4 mb-lg-0">
  <div className="sticky-image">
    <img
      src={mainLogo}
      alt="Education Icon"
      className="w-100"
      style={{
        maxHeight: "450px", // حدد أقصى ارتفاع للصورة بدل الـ Div
        objectFit: "contain",
      }}
    />
  </div>
</div>

        {/* Education Details Section */}
        <div className="col-lg-6">
          <div>
            <span className="spanEffect mt-4 text-success">Education</span>
            <h1 className="mt-3" style={{ fontSize: "2rem" }}>My Technical Journey</h1>
            <p className="pEffect">
              I’ve built my career as a passionate Full Stack Developer, mastering both frontend and backend technologies. 
              My education and certifications reflect a strong foundation in software development, networking, and cybersecurity.
            </p>
          </div>

          <div className="d-flex flex-column experiences">
            {/* Education 1 */}
            <div className="experience d-flex gap-4 mt-4">
              <div className="icon d-flex align-items-start mt-4">
                <img
                  src={edu1}
                  className="w-25 rounded"
                  alt="Frontend Developer Icon"
                />
              </div>
              <div className="explian my-4">
                <strong className="text-effect"
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    display: "inline",
                    margin: 0,
                  }}
                >
                  Frontend Development — React, HTML, CSS, JavaScript
                </strong>
                <p className="pEffect mt-3">
                  Focused on building responsive and dynamic user interfaces with React, Bootstrap, and advanced CSS animations. 
                  Experienced in creating seamless and visually appealing web experiences.
                </p>
              </div>
            </div>

            {/* Education 2 */}
            <div className="experience d-flex gap-4 mt-4">
              <div className="icon d-flex align-items-start mt-4">
                <img
                  src={edu2}
                  className="w-25 rounded"
                  alt="Backend Developer Icon"
                />
              </div>
              <div className="explian my-4">
                <strong className="text-effect"
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    display: "inline",
                    margin: 0,
                  }}
                >
                  Backend Development — Node.js, Express, MongoDB
                </strong>
                <p className="pEffect mt-3">
                  Specialized in developing powerful server-side logic and RESTful APIs using Node.js and Express, 
                  with database management in MongoDB and secure authentication systems.
                </p>
              </div>
            </div>

            {/* Education 3 */}
            <div className="experience d-flex gap-4 mt-4">
              <div className="icon d-flex align-items-start mt-4">
                <img
                  src={edu3}
                  className="w-25 rounded"
                  alt="Cybersecurity Icon"
                />
              </div>
              <div className="explian my-4">
                <strong className="text-effect"
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    display: "inline",
                    margin: 0,
                  }}
                >
                  CCNA & Cyber Security — NTI & Huawei
                  <span className="pEffect" style={{ fontSize: "0.875rem", margin: 0 }}>
                    {" "} (Certified)
                  </span>
                </strong>
                <p className="pEffect mt-3">
                  Studied advanced networking and cybersecurity fundamentals at NTI and Huawei. 
                  Gained hands-on experience in secure networking, routing, and data protection.
                </p>
              </div>
            </div>

            {/* Education 4 */}
            <div className="experience d-flex gap-4 mt-4">
              <div className="icon d-flex align-items-start mt-4">
                <img
                  src={eduLogo}
                  className="w-25 rounded"
                  alt="University Icon"
                />
              </div>
              <div className="explian my-4">
                <strong className="text-effect"
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                    display: "inline",
                    margin: 0,
                  }}
                >
                  Study in IT and Computer Science
                  <span className="pEffect" style={{ fontSize: "0.875rem", margin: 0 }}>
                    {" "} (University)
                  </span>
                </strong>
                <p className="pEffect mt-3">
                  With a strong academic background in algorithms, software engineering, and database systems, I've developed into a well-rounded developer equipped to build innovative solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Education;
